import firebase from 'firebase/app';


export const deleteAllImportedCon = (profile) =>{
    firebase.firestore()
    .collection('organizations')
    .doc(profile.company)
    .collection('importedContacts')
    .get()
    .then(res => {
        res.forEach(element => {
        element.ref.delete();
        });
    });
}